import { helpers } from '@helpers';

import { baseScreens, debugMenuScreens, onboardingScreens } from './baseScreens';
import { excludeTVOSScreens } from './excludeTVOSScreens';

export const screens = [
  ...baseScreens,
  ...onboardingScreens,
  ...(helpers.DEBUG ? [...debugMenuScreens] : []),
  ...excludeTVOSScreens,
];
